export const viewport = () => {
  let breakpoints = {
    desktop: window.innerWidth >= 1025,
    mobile: window.innerWidth <= 1024,
  }

  return {
    dimensions: {
      width: window.innerWidth, // Computed
      height: window.innerHeight // Computed
    },
    format: {
      active: (breakpoints.desktop && 'desktop' || breakpoints.mobile && 'mobile'),
      desktop: window.innerWidth >= 1025,
      mobile: window.innerWidth <= 1024
    }
  }
}
